// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__24wB9","bigColWidth":"Table_bigColWidth__2X0kx","biggerColWidth":"Table_biggerColWidth__35dmP","row":"Table_row__2MQHL","col":"Table_col__6Uf8O"};